import { fetchBlockTree, fetchNavBlocks } from '@/lib/blocks/api';
import type { BlockRecord } from '@/lib/blocks/types';

/** Read the sidebar tree (pages and databases the member can read) from the server. */
export async function loadSidebarNavBlocks(): Promise<BlockRecord[]> {
  return fetchNavBlocks();
}

export async function reloadSidebarNavBlocks(): Promise<BlockRecord[]> {
  return fetchNavBlocks();
}

export async function loadSidebarNavChildren(parentId: string): Promise<BlockRecord[]> {
  const children = await fetchBlockTree(parentId);
  return children.filter((block) => block.type === 'page' || block.type === 'database');
}
